import { getScrollTop, getScrollEventTarget } from '@theme/scroll-container';

var header = document.querySelector('header-component');
var heroImgs = document.querySelectorAll('.hero-img');
var lastScrollY = 0;
var headerOffset = 0; // 0 = fully shown, header height = fully hidden
var headerSnapTimer = null;

function setHeaderOffset(offset) {
  headerOffset = offset;
  header.style.transform = offset ? 'translateY(' + -offset + 'px)' : '';
  header.classList.toggle('mm-header-hidden', offset >= header.offsetHeight);
}

// When scrolling stops with the header half-way, settle it to whichever edge is closer.
function snapHeader() {
  var h = header.offsetHeight;
  if (headerOffset <= 0 || headerOffset >= h) return;
  header.classList.add('mm-header-snap');
  setHeaderOffset(headerOffset < h / 2 ? 0 : h);
  setTimeout(function () {
    header.classList.remove('mm-header-snap');
  }, 220);
}

function onScroll() {
  var y = getScrollTop();
  var docH = document.documentElement.scrollHeight - window.innerHeight;
  var pct = Math.min(1, y / (docH * 0.85));

  if (header) header.classList.toggle('scrolled', y > 40);

  // The header follows the finger: it slides out by exactly as much as the page
  // scrolls down and slides back in by as much as it scrolls up.
  if (header) {
    var delta = y - lastScrollY;
    lastScrollY = y;
    var menuOpen = header.querySelector('header-drawer details[open], .menu-list__link[aria-expanded="true"]');
    if (y <= 0 || menuOpen) {
      setHeaderOffset(0);
    } else {
      setHeaderOffset(Math.min(header.offsetHeight, Math.max(0, headerOffset + delta)));
    }
    clearTimeout(headerSnapTimer);
    headerSnapTimer = setTimeout(snapHeader, 150);
  }

  heroImgs.forEach(function (heroImg) {
    var heroY = Math.min(140, y * 0.14);
    heroImg.style.transform = 'scale(1.08) translateY(' + heroY + 'px)';
  });
}

// Touch/momentum scrolling can fire the scroll event many times per frame.
// Writing styles synchronously on every one of those is redundant work the
// browser has to throw away, and it's a common source of visible stutter on
// mobile. Coalesce to at most one style write per rendered frame instead.
var scrollTicking = false;
function onScrollThrottled() {
  if (scrollTicking) return;
  scrollTicking = true;
  requestAnimationFrame(function () {
    onScroll();
    scrollTicking = false;
  });
}

getScrollEventTarget().addEventListener('scroll', onScrollThrottled, { passive: true });
onScroll();

window.addEventListener('load', function () {
  heroImgs.forEach(function (heroImg) {
    heroImg.classList.add('play');
  });
  document.querySelectorAll('.hero-enter').forEach(function (el) {
    el.classList.add('play');
  });
});

// Promoting an element to its own compositor layer costs a bit of work the
// first time the browser has to do it. Doing that promotion synchronously
// with the class change that starts the transition is what causes the
// visible hitch when several cards start animating on the same frame (e.g.
// a product grid scrolling into view). Setting will-change one frame ahead
// via rAF lets the browser promote the layer before the transition kicks
// off, so the animation itself starts already-composited. The hint is
// removed again once the transition ends so idle, off-screen sections don't
// keep extra GPU layers alive indefinitely.
function triggerReveal(el) {
  el.style.willChange = 'opacity, transform';
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      el.classList.add('in');
    });
  });
  el.addEventListener(
    'transitionend',
    function () {
      el.style.willChange = '';
    },
    { once: true }
  );
}

var io = new IntersectionObserver(
  function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        triggerReveal(e.target);
        io.unobserve(e.target);
      }
    });
  },
  { threshold: 0.18, rootMargin: '0px 0px -60px 0px' }
);

function revealIfNeeded(el) {
  if (el.classList.contains('in')) return;

  var rect = el.getBoundingClientRect();
  var alreadyVisible = rect.top < window.innerHeight && rect.bottom > 0;

  if (alreadyVisible) {
    triggerReveal(el);
  } else {
    io.observe(el);
  }
}

document.querySelectorAll('.reveal').forEach(revealIfNeeded);

/**
 * Components like the variant picker and media gallery replace whole chunks of the DOM
 * with freshly server-rendered HTML (e.g. switching product size/color). That new markup
 * carries the same `.reveal` class the original elements had — starting at opacity: 0 — but
 * since it was never handed to `io`, it never receives `.in` and stays invisible forever.
 * Watch the whole document for `.reveal` elements arriving after the initial pass and hand
 * them the same treatment.
 */
var revealMutationObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType !== 1) return;

      if (node.classList && node.classList.contains('reveal')) {
        revealIfNeeded(node);
      }

      if (node.querySelectorAll) {
        node.querySelectorAll('.reveal').forEach(revealIfNeeded);
      }
    });
  });
});

revealMutationObserver.observe(document.body, { childList: true, subtree: true });
